import React, { Suspense } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

const LazyComponent = ({ children }) => (
  <Suspense fallback={<CircularProgress size={56} />}>{children}</Suspense>
);

export default LazyComponent;
